import { styled } from "@mui/material/styles";
import { Icons } from "@repo/ui";

export const PersonIcon = styled(Icons.Person)(({ theme }) =>
	theme.unstable_sx({
		width: 18,
	}),
);

export const AddressIcon = styled(Icons.Address)(({ theme }) =>
	theme.unstable_sx({
		width: 17,
	}),
);

export const PencilIcon = styled(Icons.Pencil)(({ theme }) =>
	theme.unstable_sx({
		width: "2.1rem",
		height: "2.1rem",
	}),
);

export const ContractsIcon = styled(Icons.Contracts)(({ theme }) =>
	theme.unstable_sx({
		width: 24,
	}),
);

export const FilesIcon = styled(Icons.Files)(({ theme }) =>
	theme.unstable_sx({
		width: 20,
	}),
);

export const CookieIcon = styled(Icons.Cookie)(({ theme }) =>
	theme.unstable_sx({
		width: 24,
		height: 24,
	}),
);